// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__ZxoJq","opacity-transition":"success_opacity-transition__3pKHP"};